<template>
    <div class="columns is-multiline">
        <section class="column is-full uxo-uxo-types px-0">
            <template v-if="!fetchingUxoTypes">
                <template v-for="(uxoType) in uxoTypes">
                    <div class="mb-7" v-if="uxoType.slug !== 'not-set'">
                        <div class="columns d-flex align-items-center justify-content-between mb-1">
                            <div class="column">
                                <h2 class="h1">{{uxoType.name}}</h2>
                            </div>
                            <div class="column text-right">
                                <a class="underline-link underline-navy font-weight-bold"
                                   :href="`/explosive-hazards/${uxoType.slug}`">View All</a>
                            </div>
                        </div>
                        <div class="uxo-list columns is-multiline is-mobile mb-5">
                            <template v-for="(hazard) in uxoType.hazards">
                                <div class="column is-4-mobile is-2-tablet">
                                    <a class="uxo-list__item" :href="hazardUrl(uxoType.slug, hazard.slug)">
                                        <img class="image mb-1" v-if="hazard.images" :src="hazard.images[0].aws_url"
                                             :alt="hazard.name"/>
                                        <h5 class="font-weight-normal">{{hazard.name}}</h5>
                                    </a>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="content-loader">
                    <ContentLoader
                        :height="56"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                        class="mb-2"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="460" height="56"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="56"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                    <ContentLoader
                        :height="240"
                        :width="720"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="16" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="176" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="336" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="492" y="0" rx="0" ry="0" width="140" height="140"/>
                        <rect x="16" y="156" rx="0" ry="0" width="140" height="24"/>
                        <rect x="176" y="155" rx="0" ry="0" width="140" height="24"/>
                        <rect x="336" y="154" rx="0" ry="0" width="140" height="24"/>
                        <rect x="492" y="154" rx="0" ry="0" width="140" height="24"/>
                    </ContentLoader>
                </div>
            </template>
        </section>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex";
    import {ContentLoader} from 'vue-content-loader';

    export default {
        name: "CatUxoTypes",
        components: {
            ContentLoader
        },
        data: function () {
            return {}
        },
        computed: {
            ...mapState('hazards', [
                'fetchingUxoTypes',
                'uxoTypes',
            ]),
        },
        methods: {
            ...mapActions('hazards', [
                'fetchUxoTypes',
            ]),
            hazardUrl(uxoTypeSlug, hazardSlug) {
                return `/explosive-hazards/${uxoTypeSlug}/${hazardSlug}`;
            },
        },
        created() {
            return this.fetchUxoTypes;
        },
        mounted() {

        }
    }
</script>

<style scoped lang="scss">
    .content-loader {
        min-height: rem(300px);
        min-width: rem(300px);
        width: 100%;
    }

    @media (max-width: 560px) {
        .column.is-4-mobile {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/UxoTypes.vue